import restapi from "../images/restapi.svg";
import junit from "../images/JUnit.svg";
import blender from "../images/blender.svg";
import cardio from "../images/cardio.png";
import cycle from "../images/cycle.png";
import got from "../images/got.png";
import hotelrating from "../images/hotelrating.png";
import restimage from "../images/restimage.png";
// import iotvigilant from "../images/iotvigilant.png";
import ngo from "../images/ngo.jpg";
import notes from "../images/notes.png";
import airforce from "../images/airforce.jpg";
import omnifood from "../images/omnifood.png";
import ielts from "../images/ielts.png";
import patent from "../images/patent.png";
import drivingpatent from "../images/drivingpatent.png";
import tinder from "../images/tinder.png";
import tryon from "../images/tryon.png";
import solarwind from "../images/solarwind.png";
import carparking from "../images/carparking.png";
import raj from "../images/recommend_raj.jpeg";
import puhazoli from "../images/recommend_puhazoli.jpeg";
import nawin from "../images/recommend_nawin.jpeg";
import ganesh from "../images/recommend_ganesh.jpeg";
import vadivu from "../images/recommend_vadivu.jpg";
import srinivas from "../images/recommend_srinivas.jpg";
import bravo1 from "../images/bravo1.png";
import bravo2 from "../images/bravo2.png";
export const Bio = {
  name: "Aman Pandia",
  roles: [
    "Full Stack Developer",
    "Software Architect",
    "UI/UX Designer",
    "DevOps Engineer",
    "Programmer",
  ],
  description:
    "I am a motivated and versatile professional developer with over four years of experience, always eager to take on new challenges. With a positive attitude and a growth mindset, I am working towards making meaningful contributions and achieve great things.",
  github: "https://github.com/pandiaaman",
  resume:
    // "https://docs.google.com/document/d/1PJ2vKrj5HTzy0uIw2_Aa5X0eNgX_Hdv9/edit?usp=sharing&ouid=114222733943054360696&rtpof=true&sd=true",
    "https://docs.google.com/document/d/16Q-GQro7TQoMCcDlSjXn9N3-olgy8vQW/edit?usp=sharing&ouid=114222733943054360696&rtpof=true&sd=true",
  linkedin: "https://www.linkedin.com/in/pandiaaman",
  portfoliodoc:
    "https://docs.google.com/document/d/1cmHeQjSr5JPBQjHwRyMNxeSVVXPj2hVxWZezl2zPZIM/edit?usp=sharing",
  personalhistory:
    "https://docs.google.com/document/d/1Tj29-I9HADkYlBtFx__WbhfzXeJLx9Cvo_yT3RfsI6Y/edit?usp=sharing",
  communityinvolvement:
    "https://docs.google.com/document/d/1ZB5MGIR5pvgulVR4kEJM2weGmURw1dN42VtMU2Wzbrk/edit?usp=sharing",
  leadershipdoc:
    "https://docs.google.com/document/d/17FXoyAlBP8ulhqENlJF67H3FbEg0poFpxOxRH2CgW64/edit?usp=sharing",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "TypeScript",
        image:
          "https://www.vectorlogo.zone/logos/typescriptlang/typescriptlang-icon.svg",
      },
      {
        name: "Angular Js",
        image: "https://www.vectorlogo.zone/logos/angular/angular-icon.svg",
      },

      {
        name: "Tailwind CSS",
        image:
          "https://www.vectorlogo.zone/logos/tailwindcss/tailwindcss-icon.svg",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "JAVA",
        image: "https://www.vectorlogo.zone/logos/java/java-icon.svg",
      },
      {
        name: "SpringBoot",
        image: "https://www.vectorlogo.zone/logos/springio/springio-icon.svg",
      },
      {
        name: "RestAPI",
        image: restapi,
      },
      {
        name: "Graph Ql",
        image: "https://www.vectorlogo.zone/logos/graphql/graphql-icon.svg",
      },
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "Microservices",
        image:
          "https://www.vectorlogo.zone/logos/amazon_aws/amazon_aws-icon.svg",
      },
      {
        name: "Kafka",
        image:
          "https://www.vectorlogo.zone/logos/apache_kafka/apache_kafka-vertical.svg",
      },
      {
        name: "PHP",
        image: "https://www.vectorlogo.zone/logos/php/php-icon.svg",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "Postgresql",
        image: "https://www.postgresql.org/media/img/about/press/elephant.png",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "JUnit",
        image: junit,
      },
    ],
  },
  {
    title: "DevOps",
    skills: [
      {
        name: "AWS",
        image:
          "https://download.logo.wine/logo/Amazon_Web_Services/Amazon_Web_Services-Logo.wine.png",
      },
      {
        name: "Microsoft Azure",
        image:
          "https://www.vectorlogo.zone/logos/microsoft_azure/microsoft_azure-ar21.svg",
      },
      {
        name: "Docker",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
      },
      {
        name: "Jenkins",
        image:
          "https://toppng.com/uploads/preview/jenkins-logo-11609365847mufysaivph.png",
      },
      {
        name: "Nginx",
        image: "https://download.logo.wine/logo/Nginx/Nginx-Logo.wine.png",
      },
      {
        name: "Kubernetes",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/0/00/Kubernetes_%28container_engine%29.png",
      },
    ],
  },
  {
    title: "Libraries",
    skills: [
      {
        name: "Java Collections",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
      },
      {
        name: "Hibernate",
        image: "https://www.vectorlogo.zone/logos/hibernate/hibernate-ar21.svg",
      },
      {
        name: "Mockito",
        image: "https://www.vectorlogo.zone/logos/testio/testio-icon.svg",
      },
      {
        name: "SLF4J",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSBMw6_RdwKQ9bDFfnKDX1iwMl4bVJEvd9PP53XuIw&s",
      },
      {
        name: "Redux",
        image:
          "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      },
      {
        name: "React-D3-Tree",
        image:
          "https://www.vectorlogo.zone/logos/fusion-reactor/fusion-reactor-icon.svg",
      },
    ],
  },
  {
    title: "Machine Learning",
    skills: [
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "Tensorflow",
        image:
          "https://images.seeklogo.com/logo-png/43/1/tensorflow-logo-png_seeklogo-435124.png",
      },
      {
        name: "Keras",
        image:
          "https://miro.medium.com/v2/resize:fit:600/1*DKu_54iqz6C-p6ndo7rO3g.png",
      },
      {
        name: "OpenCV",
        image: "https://www.vectorlogo.zone/logos/opencv/opencv-ar21.svg",
      },
      {
        name: "R",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1b/R_logo.svg/1086px-R_logo.svg.png",
      },
      {
        name: "SciKit Learn Kit",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/0/05/Scikit_learn_logo_small.svg/2560px-Scikit_learn_logo_small.svg.png",
      },
      {
        name: "NumPy",
        image: "https://www.vectorlogo.zone/logos/numpy/numpy-ar21.svg",
      },
    ],
  },
  {
    title: "Designing",
    skills: [
      {
        name: "Adobe XD",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQUZK5gi1clbPagXVx8PLkTK8qhlBCjve9oRw&s",
      },
      {
        name: "Figma",
        image:
          "https://s3-alpha.figma.com/hub/file/1481185752/fa4cd070-6a79-4e1b-b079-8b9b76408595-cover.png",
      },
      {
        name: "Adobe Illustrator",
        image:
          "https://www.vectorlogo.zone/logos/adobe_illustrator/adobe_illustrator-icon.svg",
      },
      {
        name: "Blender",
        image: blender,
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://e7.pngegg.com/pngimages/713/558/png-clipart-computer-icons-pro-git-github-logo-text-logo-thumbnail.png",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Eclipse",
        image: "https://www.vectorlogo.zone/logos/eclipse/eclipse-icon.svg",
      },
      {
        name: "Netlify",
        image:
          "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image:
          "https://images.g2crowd.com/uploads/product/image/fd527e1fc777d9e31b2a28e8d3c959a4/postman.jpg",
      },
      {
        name: "JIRA",
        image:
          "https://www.vectorlogo.zone/logos/atlassian_jira/atlassian_jira-icon.svg",
      },
    ],
  },
  {
    title: "Soft Skills",
    skills: [
      {
        name: "Public Speaking",
        image: "https://cdn-icons-png.flaticon.com/512/8745/8745129.png",
      },
      {
        name: "Decision Making",
        image: "https://cdn-icons-png.flaticon.com/512/10307/10307142.png",
      },
      {
        name: "Critical Reasoning",
        image:
          "https://cdn.iconscout.com/icon/premium/png-256-thumb/critical-thinking-4278958-3557318.png",
      },
      {
        name: "Delegation",
        image: "https://cdn-icons-png.flaticon.com/512/7626/7626071.png",
      },
      {
        name: "Team Collaboration",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/67/Collaboration_logo_V2.svg/607px-Collaboration_logo_V2.svg.png",
      },
    ],
  },
  {
    title: "Extra curriculars",
    skills: [
      {
        name: "Dancing-Free Sytle/Hip Hop",
        image:
          "https://cdn.iconscout.com/icon/premium/png-256-thumb/dance-27-1132079.png?f=webp",
      },
      {
        name: "Guitar",
        image: "https://freesvg.org/img/papapishu_guitar_5.png",
      },
      {
        name: "Drums",
        image:
          "https://cdn.imgbin.com/16/11/5/imgbin-snare-drums-drummer-logo-drums-Hep9SWsMEe9rzLvQKyaBRXrdX.jpg",
      },
      {
        name: "BeatBoxing",
        image:
          "https://cdn.iconscout.com/icon/premium/png-256-thumb/drum-kit-4095415-3391610.png",
      },
      {
        name: "Athletics-Relay Racing, Javelin Throw",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f6/Olympic_pictogram_Athletics_-_colored.svg/2048px-Olympic_pictogram_Athletics_-_colored.svg.png",
      },
    ],
  },
];

export const recommendations = [
  {
    id: 0,
    img: "https://media.licdn.com/dms/image/v2/C4E03AQGF8MKVjQYmOA/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1517574598892?e=1762992000&v=beta&t=ydz4yiCujpooLrqoGw4VW7ZcuYEXhzxK8mLPzWFVbnA",
    role: "Nico Ludwig",
    company:"Principal Software Engineer at Avid Technology",
    date: "Senior Team Member",
    desc: "I had the pleasure of working alongside Aman on several projects, and his combination of team spirit and eagerness to learn always stood out. He consistently takes ownership, drives initiatives forward, and is always ready to support others when needed. Aman is highly analytical, asks the right questions, and demonstrates the ability to master complex tasks. His accountability and collaborative nature made working with him both productive and enjoyable. Any team would be fortunate to have him.",
  },
  {
    id: 1,
    img: raj,
    role: "Arunachalam Rajalingam",
    company:
      "Sr. Solutions Architect at The Hanover Insurance (Ex-VP State Street)",
    date: "Managed Aman directly",
    desc: "Aman began his professional career as an application developer in State Street under me. I mentored him with his JAVA application development skills and have observed his impeccable learning curve and swift growth in the field since then. He is a valuable addition to the team and has immaculate ethics and teamwork abilities. He has proven his potential to work around complex and diverse situations. He shows constructive engagement with every project and task assigned to him, making him a proactive coworker and a polished professional. He has shown tremendous progress in his coding and development expertise by showing consistent motivation and delivering timely results. I look forward for him to achieve greater heights in his career.",
  },
  {
    id: 2,
    img: "https://media.licdn.com/dms/image/v2/C5603AQEu_-uhDVNcGw/profile-displayphoto-shrink_400_400/profile-displayphoto-shrink_400_400/0/1661683765886?e=1762992000&v=beta&t=pPVGm0r-Fo3jJ8aYZ3JYZXiuYmLYicMMplhoCNjZNgY",
    role: "Praveen Naregal",
    company:
      "Head of Engineering at GlobalLogic Media & Entertainment Delivery",
    date: "Managed Aman directly",
    desc: "I highly recommend Aman for his outstanding contributions as a senior software engineer on our team. Aman has consistently demonstrated expertise in designing and developing robust, scalable applications using Java Spring Boot, React and AWS. His ability to lead technical initiatives, mentor team members, and drive projects to timely completion has made a significant positive impact on our organization. He is proactive, reliable, and a collaborative team player who consistently upholds best practices while bringing out the best in those around him. It has been a pleasure having Aman as a valuable member of our team.",
  },
  {
    id: 3,
    img: puhazoli,
    role: "Puhazoli Saravanan",
    company: "Research Scholar (Ex-Professor, SRM IST)",
    date: "Mentor in multiple research projects",
    desc: "Aman has been one of the brightest students I have known and is as diligent and hard working. His advanced skills and passion for any or all technologies and his aptitude for coding makes him an asset to have. I was a guide to Aman and his team for their pre final and final year projects in college, and I am elated to see how Aman put in all his hard work to get patents for both the ideas and managed the team with his amazing leadership skills. His personal strengths are as impressive as his intellectual achievements. It always has been one of the best experience teaching and working with Aman and observing his success in the field as well as his impeccable growth. Aman has my highest recommendation and support",
  },
  {
    id: 4,
    img: nawin,
    role: "Nawin Subbu Saravanakumar",
    company: "Senior Associate at StateStreet | IIMK",
    date: "Team Senior",
    desc: "When I switched domains to become a developer, even though I was ahead on years of experience as a professional I was still a novice in this domain. Aman helped me grasp the concepts swiftly. He helped me understand complex ideas and methods with ease. Truly remarkable person to work with and have in our team.",
  },
  {
    id: 5,
    img: ganesh,
    role: "Ganesh Malasetty",
    company: "Java Full Stack Developer, StateStreet",
    date: "Colleague",
    desc: "I started my journey in State Street with Aman solely working on the project, he helped me understand the company’s internal process and introduced me to the application and its critical details. His work ethics are immaculate, and he is easily adjustable to a given situation. He is willing to put that extra help whenever you need it and always takes the time to support anyone is his network. It was an amazing experience working with such proactive, self motivated and intelligent team player. I highly recommend him.",
  },
  {
    id: 6,
    img: vadivu,
    role: "Dr. Vadivu G",
    company: "H.O.D., IT Dept., SRM IST, Chennai",
    date: "Mentor and Professor",
    desc: "Academically, Aman consistently achieved remarkable results, always exceeding our expectations. What particularly impressed me were his team management and leadership skills. I have personally observed his technical acumen and his keenness to apply his knowledge to real-world projects to the fullest extent. Aman's final-year project, 'Vigilant Stick' for visually impaired individuals. Aman is an exceptional candidate who has demonstrated notable commitment, innovation, and problem-solving skills ",
  },
  {
    id: 7,
    img: srinivas,
    role: "Dr. L.N.B. Srinivas",
    company: "Professor, Data Science Dept., SRM IST, Chennai",
    date: "Professor",
    desc: "Aman's 'learning by teaching' approach was a noteworthy aspect of his participation in my class. His earnest enthusiasm for teaching others had not only expanded his understanding of different subjects but also ignited a curiosity for acquiring new skills and knowledge. His problem-solving skills, along with his firm commitment to applying acquired knowledge to real-world projects, have always confounded me.",
  },
];

export const certifications = [
  {
    id: 0,
    img: "https://d1.awsstatic.com/onedam/marketing-channels/website/aws/en_US/certification/approved/images/certification-badges/saa-badge-resized.00acb1ad694d205f0c41d050db69d4706633607a.png",
    role: "AWS Certified Solutions Architect – Associate",
    company: "AWS",
    date: "Issued Sep 2025",
    desc: "• Credential ID 8533b4bfeb45456aaae677e95a7c5ddb",
    skills: [
      "AWS",
      "Cloud Infrastructure",
      "Networking",
      "Cloud Computing",
      "Cloud Deployment",
      "AI/ML",
    ],
    doc: "https://www.credly.com/badges/e6f98ff8-d48c-41a6-91f0-f03ad220417c/linked_in_profile",
  },
  {
    id: 1,
    img: "https://img-c.udemycdn.com/course/750x422/5418930_531f_2.jpg",
    role: "Oracle Cloud Infrastructure 2025 Certified Architect Associate",
    company: "Oracle",
    date: "Issued Oct 2025",
    desc: "• Credential ID 8C724E0B2567F89B4EFEAABD",
    skills: [
      "OCI",
      "Oracle Cloud",
      "Networking",
      "Cloud Security",
    ],
    doc: "https://catalog-education.oracle.com/pls/certview/sharebadge?id=8C724E0B2567F89B42B1A6D37D15BA4B9960364910B08BDED4CFFF332EFEAABD",
  },
  {
    id: 2,
    img: "https://www.loffler.com/hubfs/Microsoft%20Azure%20Blog.jpg",
    role: "Microsoft certified Azure AI Fundamentals",
    company: "Microsoft",
    date: "Issued Jun 2021",
    desc: "• Credential ID H883-9309",
    skills: [
      "Azure",
      "AI",
      "Data Science",
      "Machine Learning",
      "Deployment",
      "Cloud",
    ],
    doc: "https://mcptnc.microsoft.com/certificate?AttemptMsaSilentAuth=true&wa=wsignin1.0",
  },
  {
    id: 3,
    img: "https://images.credly.com/images/7562bf68-c3a6-4d79-9154-00ee605b9492/UX.png",
    role: "Foundations of User Experience (UX) Design",
    company: "Google",
    date: "Issued Jan 2023",
    desc: "• Credential ID HSEZ55LEEYJU",
    skills: [
      "UI/UX",
      "Web Development",
      "Designing",
      "Story mapping",
      "user stories",
      "requirement analysis",
    ],
    doc: "https://www.coursera.org/account/accomplishments/verify/HSEZ55LEEYJU",
  },
  {
    id: 4,
    img: "https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/e8/7cc3d09d3f11e698dfff46d35f2da1/Stanford_Coursera_Logo.png?auto=format%2Ccompress&dpr=1&w=80&h=80",
    role: "Machine Learning",
    company: "Stanford University",
    date: "Issued May 2018",
    desc: "• Credential ID 2NL84GHSRYQH",
    skills: [
      "Machine Learning",
      "Neural Networks",
      "Regression",
      "supervised learning",
      "unsupervised learning",
    ],
    doc: "https://www.coursera.org/account/accomplishments/verify/2NL84GHSRYQH",
  },
  {
    id: 5,
    img: "https://www.loffler.com/hubfs/Microsoft%20Azure%20Blog.jpg",
    role: "Microsoft certified Azure Data Fundamentals",
    company: "Microsoft",
    date: "Issued Jun 2021",
    desc: "• Credential ID H880-2992",
    skills: [
      "Azure",
      "AI",
      "Data Science",
      "Business Analytics",
      "Deployment",
      "Cloud",
    ],
    doc: "https://mcptnc.microsoft.com/certificate?AttemptMsaSilentAuth=true&wa=wsignin1.0",
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://www.globallogic.com/wp-content/uploads/2021/11/Wordmark-2.png",
    role: "Senior Software Engineer (Team Lead)",
    company: "Hitachi GlobalLogic Private Limited",
    date: "March 2025 - current",
    desc: "• Built reactive Java Spring Boot and FastAPI microservices leveraging asynchronous WebClient, and deployed them using AWS tools like Fargate, and SQS, resulting in a significant reduction of API response times and developed the CTMS Registry, a key microservice for seamless service discovery and inter-service communication in cloud and on-premises Kubernetes environments of existing customers. ",
    skills: [
      "SpringBoot",
      "JAVA microservices",
      "System Design",
      "CI/CD",
      "Docker",
      "Kubernetes",
      "FastAPI-Python",
      "AWS",
      "RestAPI",
      "OpenAPI/Swagger"
    ],
    doc: "https://drive.google.com/file/d/1aN_Ywu1xRnKZ9EtFG445ZWmd9_tYYTZs/view?usp=sharing",
  },
  {
    id: 1,
    img: "https://www.globallogic.com/wp-content/uploads/2021/11/Wordmark-2.png",
    role: "Senior Software Engineer",
    company: "Hitachi GlobalLogic Private Limited",
    date: "June 2024 - Feb 2025",
    desc: "• Extended and enhanced CloudUX Starter Kits with new features and bug fixes, streamlining onboarding and boosting product revenue within one quarter of deployment and led the adoption of standardized OpenAPI guidelines to unify API design across organizational products and services, driving seamless integration and better developer experience with SDKs and customer services. ",
    skills: [
      "ReactJS",
      "TypeScript",
      "JavaScript",
      "Docker",
      "Kubernetes",
      "NPM",
      "Python",
    ],
    doc: "https://drive.google.com/file/d/1aN_Ywu1xRnKZ9EtFG445ZWmd9_tYYTZs/view?usp=sharing",
  },
  {
    id: 2,
    img: "https://images.seeklogo.com/logo-png/50/1/state-street-logo-png_seeklogo-504110.png",
    role: "Senior Associate (Team Lead)",
    company: "State Street Services Corportate Private Limited",
    date: "Feb 2023 - current",
    desc: "• Orchastrated a team of 4 members in a critical JAVA microservices project, rebuilding the legacy systems overall while implementing event driven architecture using Kafka and Jenkins for automated deployment with docker and kubernetes. Updated Frontend UI/UX using React JS based on business requirements of the onshore banking teams. ",
    skills: [
      "JAVA microservices",
      "Kafka",
      "Jenkins",
      "Docker",
      "Kubernetes",
      "React JS",
      "AWS",
      "IBM MQ",
      "JavaScript",
    ],
    doc: "https://drive.google.com/file/d/14-lJmZdif7a7tneuX29d0SD0aMYb8OM0/view?usp=sharing",
  },
  {
    id: 3,
    img: "https://images.seeklogo.com/logo-png/50/1/state-street-logo-png_seeklogo-504110.png",
    role: "Senior Associate (Full Stack Application Development / Maintenance)",
    company: "State Street Services Corportate Private Limited",
    date: "Oct 2021 - Jan 2023",
    desc: "• Collaborated in architecting low-level and high-level designs, analyzing and working on requirements along with multiple onshore business and corss-functional teams. I automated daily NAV calculations using JAVA Quartz framework and JSP Servlet technology.",
    skills: [
      "Java JSP-Servlets",
      "JUnit",
      "SLF4J",
      "SpringBoot",
      "Spring MVC",
      "JavaScript",
      "TypeScript",
      "PL-SQL",
      "Redis",
    ],
    doc: "https://drive.google.com/file/d/1ovFZE1jSkyYnLPy9njQ_QqrmpbbXbKk1/view?usp=sharing",
  },
  {
    id: 4,
    img: "https://images.seeklogo.com/logo-png/50/1/state-street-logo-png_seeklogo-504110.png",
    role: "Associate-2 (Application Development / Maintenance)",
    company: "State Street Services Corportate Private Limited",
    date: "Jul 2020 - Sep 2021",
    desc: "• Solely handled the integration of middleware applications using RESTful APIs using custom API endpoints and OAuth authentication, achieving secure data transfer. Utilized CI/CD pipelines with Jenkins deployment. This also needed in-depth understanding of all the core logics of finance and accounting which gave me a great opportunity to grasp all business requirements.",
    skills: [
      "Finance Business",
      "Java",
      "Hibernate",
      "Ci/CD",
      "Restful API",
      "Figma",
    ],
    doc: "https://drive.google.com/file/d/1ovFZE1jSkyYnLPy9njQ_QqrmpbbXbKk1/view?usp=sharing68b-422d-bd0b-1f125f722245",
  },
  {
    id: 5,
    img: "https://images.seeklogo.com/logo-png/50/1/state-street-logo-png_seeklogo-504110.png",
    role: "Associate-1 (Application Development)",
    company: "State Street Services Corportate Private Limited",
    date: "July 2019 - Jun 2020",
    desc: "• Modernized legacy applications and supervised their seamless transformation to core Java with GWT, Hibernate, and PostgreSQL, significantly improving the user experience while staying well under budget. Conceptualized training sessions for junior team members on managing requirements effectively and writing scalable, and maintainable code.",
    skills: [
      "Java Core",
      "JavaScript",
      "Hibernate",
      "IBM SQL",
      "Gooogle Web Tool Kit",
      "HTML",
      "CSS",
      "SQL",
    ],
    doc: "https://drive.google.com/file/d/1ovFZE1jSkyYnLPy9njQ_QqrmpbbXbKk1/view?usp=sharing",
  },
  {
    id: 6,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSTBFNH0KmAm4Vub-S5TOlh7mZzvtz-vUhsCYhkceNANg&s",
    role: "Intern-Application Developer",
    company: "Mercury Digital",
    date: "June 2018 - July 2018",
    desc: " Developed fast and secure website for a project of Rajasthan Government, called Suraaj.com, implementing backend web development skills using PHP along with codeIgniter framework. I also worked on designing and coding the user interface using Javascript. For designing, I exoplored tools like Figma and Adobe Illustrator.",
    skills: [
      "PHP CodeIgnitor",
      "Object Oriented Programming",
      "Figma",
      "Adobe Illustrator",
      "UI UX designing",
    ],
    doc: "https://drive.google.com/file/d/1Tzaai1jNexb3gAg_z4d49Vs3ybvvXQnn/view?usp=sharing",
  },
  {
    id: 7,
    img: "https://www.equitybulls.com/equitybullsadmin/uploads/Mangalam%20Cement%20Limited%204.jpg",
    role: "Intern-Application Developer",
    company: "Birla Uttam Cement Private Limited",
    date: "June 2017 - July 2017",
    desc: "Researched on 'Use cases of Drone', a critical region detection in mine terrains of the industry by implementing image analytics and detection using Python and OpenCV. Worked with few of the best minds in the industry, understanding in detail about the cement industries and their needs.",
    skills: [
      "Research",
      "Drone Programming",
      "Python",
      "Open CV",
      "Team collaboration",
    ],
    doc: "https://drive.google.com/file/d/15hIjCjbcalGNZRH1dSspy860xvp5GJZe/view?usp=sharing",
  },
  {
    id: 8,
    img: "https://media.licdn.com/dms/image/C560BAQG84msMWQwyJg/company-logo_200_200/0/1630565255020/team_srmsat_space_systems_laboratory_logo?e=2147483647&v=beta&t=VJrl9tEPWGNQb4qmjvo9n7XPEhiQh0Wa9KmnSM7EgP4",
    role: "Team Lead-Attitude Determination and Control System",
    company: "SRM-SAT",
    date: "Feb 2016 - July 2018",
    desc: "As a first-year undergrad, I joined the SRM's most prestigious student-led club, SRMSAT, dedicated to developing a low-earth orbit satellite to combat global warming by monitoring atmospheric pollution levels. I was guided by few of the best minds in ISRO, who helped me in my extensive research on multiple disciplines like spacecraft dynamics, aerospace engineering and sensor programming.",
    skills: [
      "Leadership",
      "Aerospace engineering",
      "Sensor programming",
      "IoT",
      "Satellite development",
      "Matlab",
      "R",
      "Python",
    ],
  },
  {
    id: 9,
    img: "https://aaruush22-bucket.s3.ap-south-1.amazonaws.com/main/aaruush.png",
    role: "Associate Secretary",
    company: "Operations and Resource Management team-Aarush Festival",
    date: "May 2019 - June 2019",
    desc: "Successfully organized SRM’s leading tech-fest, Aarush, by managing and maintaining all necessary requirements for the incoming students and visitors of the festival.",
  },
];

export const education = [
  {
    id: 0,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTMwlmND_JZRV7PfYxpCHMEB7JgUCImn1NZVQ&s",
    school: "BITS Pilani",
    date: "Jun 2023 - July 2025",
    grade: "92%",
    desc: "Pursuing Masters of technology in Software Engineering, to further my understanding and learning towards this wide domain. Keeping up with my enthusiasm and dedication to always keep learning and evolving, I look forward to gain vital knowledge in the field by gaining hands on experience in DevOps, AWS, SpringBoot, React, High and low level designing and other critical tools and technologies.",
    degree: "M. Tech., Software Engineering (Full stack Specialization)",

    transcripts:
      "https://drive.google.com/file/d/1f_ruI5dHhtD9TXB_sM-4FscQusB-ZYW5/view?usp=sharing",
  },
  {
    id: 1,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSX0WHeIh88dBrqCD9HTlqqZ9WghwwvDQwtt5HRId-_eZgf7YvDM_DlfQHwBvUFUOhduXg&usqp=CAU",
    school: "SRM Institute of Science and Technology, Kattankulathur, Chennai",
    date: "June 2015 - May 2019",
    grade: "90.08%",
    desc: "Pursuing bachelors in information technology, I completed a fulfilling journey over the span of four years at SRM IST, Chennai. From participating in many extra curricular activities to being a team lead of college's most prestigious club, SRMSAT, my time at SRM has been full of challenges, learnings and growth. The university has supported my innovative ideas and has helped me receive two patents for my work.",
    degree: "Bachelor of Technology - BTech, Information Technology",
    degreedoc:
      "https://drive.google.com/file/d/16M8K66i_F3BnHA8rR-hMEHE210EzmCNk/view?usp=sharing",
    transcripts:
      "https://drive.google.com/file/d/1igZj9AOsL3CiMS2Lo-q9S5ho3bfczIXA/view?usp=sharing",
    scholarogrades:
      "https://drive.google.com/file/d/1WgpdZ17W4mOvpT_3vSxhMXPHCtjbD0mR/view?usp=sharing",
  },
  {
    id: 2,
    img: "https://p.kindpng.com/picc/s/358-3586770_great-lakes-logo-great-lakes-institute-of-management.png",
    school: "Great Lakes Institute, Chennai",
    date: "Dec 2019 - July 2019",
    grade: "95%",
    desc: "Looking to expand my knowledge in the filed of data science and machine learning, I pursued a diploma in Business analytics program at Great lakes. From getting training from the best minds in the industry to getting an amazing in-depth knowledge in the subject with practical implementation using many project opportunities, my time at Great Lakes has helped me become a better professional and a developer.",
    degree: "Diploma, Business Analytics Certification Program",
    degreedoc: "https://olympus1.mygreatlearning.com/certificate/JIQXTLUX",
    transcripts: "https://eportfolio.mygreatlearning.com/aman-pandia",
  },
];

export const patents = [
  {
    id: 0,
    image: patent,
    title: "Vigilant Stick: Intuitive Navigation Guidance",
    role: "Team Lead",
    date: "July, 2018",
    about:
      "With Over 15 million blind people in India (according to a survey report in 2019), the project aimed to develop a smart solution for visually impaired individuals to aid them in navigation while keeping their comfort and safety as a priority. The product aims to sense the surroundings of the users for any obstacles or moving vehicles and provide real-time sensory and vocal outputs to the users, providing them with continuous feedback and making their navigation easier.",
    description:
      "Implemented an innovative solution to aid visually impaired in navigation, blending IOT, web development, machine learning, and Android technologies, culminating in a patent awarded in February 2020. Utilized OpenCV with Raspberry Pi camera and sensor fusion in order to provide real-time environmental assessment for users, providing continuous feedback to users using vibration actuator and speech output.",
    learnings:
      "Implementation of machine learning algorithms for image analysis, detection, tracking, and prediction helped me understand the value of data in real-world scenarios. Explored multiple use cases of IOT technology and its interconnection with other disciplines such as web development, android development, and machine learning.",
    teamsize: "3",
    tags: [
      "IOT",
      "Machine Learning",
      "Python",
      "Raspberry Pi",
      "Open CV",
      "Sensor programming",
      "LSTM algorithm",
      "Deep Neural Network",
      "Web development",
    ],
    category: "all",
    github: "https://github.com/pandiaaman/VigilantStick",
    patentlink:
      "https://www.google.co.in/url?sa=t&source=web&rct=j&url=http://www.ipindia.nic.in/writereaddata/Portal/IPOJournal/1_2631_1/Part-1.pdf&ved=2ahUKEwit5pCx2frcAhURcCsKHdJ2CGEQFjAAegQIABAB&usg=AOvVaw1LXS2jxXEcCW7dtPQlfE1K",
    patentdoc:
      "https://drive.google.com/file/d/1D7DBeVtWyy3a70MaD6p31qUAGkyfk1oF/view?usp=sharing",
    reportlink:
      "https://docs.google.com/document/d/10lOna-BZFWm4fPynibTxmIaYTlLVxjeF/edit?usp=sharing&ouid=114222733943054360696&rtpof=true&sd=true",
  },
  {
    id: 1,
    image: drivingpatent,
    title: "Driving Evaluation and Assessment System",
    role: "Team Lead",
    date: "March, 2020",
    about:
      "The ever-increasing number of road casualties and lack of importance given to safety measures by drivers across the world has become the need of the hour. This project is a step taken towards increasing driver reliability by having proper assessments using continuous input. The system is needed to accurately collect data, process and assess it to make judgments about the driving skills of individuals and compare them with each other.  The system is developed mainly for cab drivers, truck drivers, and drivers in school/college fleets, who are managing transportation and logistics of valuables in their day-to-day lives. ",
    description:
      "Patented an automated, reliable, and robust driving assessment system in July 2018, for comprehensive driving evaluation. Utilized supervised machine learning algorithms like Decision tree for continuous vehicle motion detection and analysis. Led a team of four to develop a system using Arduino controller in conjunction with on-board sensors like gyroscope and AMU (acceleration measurement unit). System stored the recorded data in a data warehouse and implemented OLAP to find trends.",
    learnings:
      "Development of IOT code using a diverse range of sensors with the Arduino controller, helped me understand different ways to tackle and analyze real-time data. Web development using PHP to develop a stateful application with detailed session management and login system provided deep insights into the software development process as a whole. ",
    teamsize: "4",
    tags: [
      "Automobile",
      "Machine Learning",
      "Python",
      "Decision Tree",
      "AMU",
      "Sensor programming",
      "OLAP",
      "SQL",
      "Statistics",
    ],
    category: "all",
    github: "https://github.com/pandiaaman/PrecisionDrivingEvaluationSystem",
    patentlink:
      "https://www.google.co.in/url?sa=t&source=web&rct=j&url=http://www.ipindia.nic.in/writereaddata/Portal/IPOJournal/1_2631_1/Part-1.pdf&ved=2ahUKEwit5pCx2fr",
    patentdoc:
      "https://drive.google.com/file/d/1D7DBeVtWyy3a70MaD6p31qUAGkyfk1oF/view?usp=sharing",
    reportlink:
      "https://docs.google.com/document/d/1kVKzg2LHayAJrqbiCTodXpZ5Xqec2CQR/edit?usp=sharing&ouid=114222733943054360696&rtpof=true&sd=true",
  },
];

export const projects = [
  {
    id: 0,
    title: "Designing a Bicycle Shopping Mobile App",
    role: "independent project",
    date: "Jan 2023",
    about:
      "The project aimed at designing a simplistic yet effective UI experience for all shoppers interested in buying bicycles through an Android or iOS app. The product was created for a fictional brand with the motivation to increase the number of returning users and retain first-time buyers as long-term customers.",
    description:
      "Being the sole designer of the project, I undertook the roles of UI/UX designer, researcher, and reviewer, undertaking complete user research, creating user personas and user journey maps, developing competitive audits, and conducting usability studies. As a designer, I used Figma and other designing tools and resources available to me for creating multiple paper sketches to select the best options, creating digital wireframes and low-fidelity prototypes, and completing a usability study to utilize further the results of the study in developing mock-ups.",
    learnings:
      "This real-world case study of creating a robust and effective design for a bicycle shopping app taught me the importance of serving customers of all demographics as equals and having an easy-to-understand UI along with an enjoyable user experience. I learned the importance of UI and UX design in the world of web development. As a software developer, going through the process of designing UI and UX for users helped me understand the nuances in the field and its interconnection with the development process.",
    image: cycle,
    tags: [
      "UI/UX",
      "Figma",
      "Adobe Illustrator",
      "wireframing",
      "storyboarding",

      "user scenarios",
      "user stories",
    ],
    category: "uiux",
    github: "",
    webapp: "",
    portfolio:
      "https://docs.google.com/presentation/d/1rSru9H9ImTrB4MUxrQokDVRHM8zTxba796GSv6C9x7I/edit?usp=sharing",
  },
  {
    id: 1,
    title: "Designing Mobile 3D Virtual TryOn Clothing Application",
    role: "independent project",
    date: "Oct 2023",
    about:
      "This project aims to develop and design an application to make virtual try-ons even more lifelike and customizable. It explores the use of AI algorithms that can suggest clothing items or accessories based on the user's style preferences, current selection, past purchases, and the items they've tried virtually. The project was undertaken as an opportunity to develop an actual product with a team of four members, where I handled the design aspect of the application.",
    description:
      "To get a better understanding of the product and the market, deep research was carried out to understand the customer segments, the underserved needs of the users by the existing brands, and hence the pain points of the users. A proper customer survey and feedback process was carried out to understand the needs and develop a value proposition using the feedback. Story mapping and startup canvas processes were completed, followed by designing low-fidelity and high-fidelity prototypes and wireframing to bring the ideas to life.",
    learnings:
      "Understood the importance of translating solutions into a user-centric experience through wireframe storyboarding, keeping the end user in focus. Understood the value of iterative design processes, continuous feedback, visual consistency, and a user-centered design process to develop a fulfilling and enriching experience for the users.",
    image: tryon,
    tags: [
      "Research",
      "UI/UX",
      "Figma",
      "Adobe Illustrator",
      "wireframing",
      "storyboarding",
      "design testing",
    ],
    category: "uiux",
    github: "",
    webapp: "",
    portfolio:
      "https://docs.google.com/presentation/d/1-cFFJ6wxWp-j9tflGpl2iu0XKU5XR-S-8efGbKUNrNo/edit?usp=sharing",
  },
  {
    id: 2,
    title: "Designing and Developing a Gallery Using API",
    role: "independent project",
    date: "April 2022",
    about:
      "A front-end project exploring using APIs with a web application developed in React and Tailwind CSS. To fetch the multiple images, we use Pixabay API (Pixabay API documentation). The motive is also to make the page look uniform and have a proper pagination process to make the search results more readable for the user. The styling of the web app is done using Tailwind CSS utility classes to provide a card look and feel to each image that is loaded on the screen and explored using the Tailwind framework with React.",
    description:
      "Using the Post CSS in the application, we import all the required Tailwind CSS features in the React application. The project explores creating Tailwind Cards components, API Keys, and tags to provide better insights into the fetched images for the users. For the image search component, we explore the React States and props management within the application. ",
    learnings:
      "The project provided insights into using Tailwind CSS with a React application while adhering to proper design and front-end development patterns and principles. The use of external APIs in the frontend applications is another critical learning out of this project. The gallery application puts the user experience as a priority and informs on how the use of simple colors, designs, and design systems in general can help us to make our web apps look better.",
    image: restimage,
    tags: [
      "Rest API",
      "ReactJS",
      "TailwindCSS",
      "PostCSS",
      "API Keys",
      "user scenarios",
      "user stories",
    ],
    category: "frontend",
    github: "https://github.com/pandiaaman/ReactWithTailwindImageSeachAPI",
    webapp: "https://amanreacttailwindapp.netlify.app/",
    portfolio: "",
  },
  {
    id: 3,
    title: "Designing and Developing a Food Delivery App’s Landing Page",
    role: "independent project",
    date: "Feb 2023",
    about:
      "A responsive landing page for an upcoming fictional food delivery brand, prioritizing healthy food and provision of different meals cooked by professional chefs and delivered to the user at their doorstep. The project involves developing a web app using a core tech stack of HTML, CSS, and JavaScript.",
    description:
      "Using core HTML, CSS, and JavaScript, the main focus was to create a responsive landing page with all the design system principles followed. Browser’s DevTools are used to verify the strength of the product, using performance insight tools like LightHouse and others. ",
    learnings:
      "I understood the process of requirement gathering before starting any front-end project. The value of developing a proper design system for an app and its key role as the project grows gets clearer. I learned the proper usage of DevTools provided by the browsers and the value of feedback we can receive from multiple tools it has. Utilized the CSS grid and flexbox at multiple places, helping me understand the correct usage of both the tools at our disposal.",
    image: omnifood,
    tags: [
      "HTML",
      "CSS",
      "JavaScript",
      "Tailwind CSS",
      "PostCSS",
      "WebPack",
      "Frontend System Design",
      "UI/UX",
    ],
    category: "frontend",
    github: "https://github.com/pandiaaman/OmniFoodWebsiteCore.git",
    webapp: "https://omnifood-amanpandia.netlify.app/",
    portfolio: "",
  },
  {
    id: 4,
    title: "Hotel Rating App using Spring Microservice and RestAPI",
    role: "independent project",
    date: "Sep 2023",
    about:
      "The project “Hotel Rating App” using Spring Boot Microservices and RestAPI is an effort to explore the microservice domain and its related design patterns to implement a functioning robust web application. Using multiple microservices, the app provides various Rest endpoints for the users to rate and book hotel rooms and will be able to check the ratings of other users on a given hotel property. ",
    description:
      "Exploring the “right” way to develop a microservice backend architecture with RestAPI, the project explores the use of multiple microservices, their connections using Feign client, an API gateway for accepting requests, and a Service Registry to manage all the services along with a config server. By using Spring Security and proper exception handling for the system, the DTOs are designed for resilience and are error-prone, along with having a robust MongoDB database setup with Hibernate. ",
    learnings:
      "I learned how to use various microservices design patterns with SQL and NoSQL databases to have an available, maintainable, and consistent system. I understood the use of various microservices concepts like API gateways, and Service Registry, along with implementing Circuit breaking and rate limiting with Resilience 4J. ",
    image: hotelrating,
    tags: [
      "microservices",
      "JAVA SpringBoot",
      "Backend",
      "System Desing",
      "RestAPI",
      "GraphQL",
      "Redis cache",
      "MongoDB",
    ],
    category: "backend",
    github: "",
    github1:
      "https://github.com/pandiaaman/MicorserviceHotelRatingAppAPIGateway/tree/master",
    github2:
      "https://github.com/pandiaaman/MicroserviceHotelRatingAppConfigService/tree/master",
    github3:
      "https://github.com/pandiaaman/MicorserviceHotelRatingAppServiceRegistry/tree/master",
    github4:
      "https://github.com/pandiaaman/MicorserviceHotelRatingAppHotelService/tree/master",
    github5:
      "https://github.com/pandiaaman/MicorserviceHotelRatingAppUserService/tree/master",
    github6:
      "https://github.com/pandiaaman/MicorserviceHotelRatingAppRatingService/tree/master",
    webapp: "",
    portfolio: "",
  },
  {
    id: 5,
    title: "Designing and Architecting the Tinder App",
    role: "independent project",
    date: "Mar 2022",
    about:
      "The project explores the multiple challenges in architecting an application from scratch. To develop a proper working replica of the Tinder app, which is robust, scalable, available, and secure to use ",
    description:
      "Explores the use of the Top-Down approach in the process of architecting web applications. The project develops on the basic understanding of various features of the application, starting from requirement gathering, such as functional and non-functional requirements, to finally selecting the ASRs (Architecturally Significant Requirements). Discusses the many tactics available to apply the discussed ASRs to the application. Draws the value by developing a C&C diagram(Component and Connector), Sequence Diagram, and a Use-Case Diagram, to understand the various architectural patterns that can be used to solve the challenges. ",
    learnings:
      "This project helped me understand the flow of decision-making steps that need to be undertaken during the designing and architecting of a web application. The use of various tactics such as client-end and server-end caching, along with horizontal and vertical scaling options, helped me understand the value of understanding the user needs and the needs of the project and their role in decision-making as an architect. I also understood that combinations of architectural patterns are necessary to solve a problem as no single pattern is a “one-size-fits-all” solution.",
    image: tinder,
    tags: [
      "Software Architecture",
      "OOPS",
      "GeoLocation",
      "SOLID",
      "event driven architecture",
    ],
    category: "backend",
    github: "",
    webapp: "",
    portfolio:
      "https://docs.google.com/presentation/d/1L-Ce_12horacsYJRxGnQlF72hQt46EFAoPKEFUnh66o/edit?usp=sharing",
  },

  {
    id: 6,
    title: "GOT Family Tree Full stack app",
    role: "independent project",
    date: "Nov 2022",
    about:
      "The project “GOT family tree”, started as a fun side project to explore my interest in the famous TV series, Games Of Thrones. The project was about building a full-stack app using Spring Boot, React, and JavaScript and exploring a React library called React-D3-Tree, used for developing tree-like structures with React components. The project also explores a JSON data file with all the GOT series characters and their various features in the dataset ",
    description:
      "The backend with Spring Boot, contains the perfect project structure for a given Java application, with correctly distributed DTOs, Controllers, Models, and Business layers. Proper exception handling with custom exceptions using Spring is also implemented, along with Hibernate to manipulate data present in the PostgreSQL DB. Using React as the frontend library, with React-D3-Tree, proper state management along with routing throughout the application is utilized. ",
    learnings:
      "This project helped me explore the Breadth-First traversal quality of trees, to forward data from the backend to the frontend using CORS and RestAPI. Explored the true nature of a full stack web development using proper development, testing, and feedback loop cycles by employing different agile principles. ",
    image: got,
    tags: [
      "React Js",
      "React-D3-Tree",
      "SpringBoot",
      "CORS",
      "Redux",
      "React Flow",
      "MongoDB",
      "Full-stack",
    ],
    category: "fullstack",
    github1:
      "https://github.com/pandiaaman/GOTFamilyTreeReactSpringRest/tree/master",
    github2: "https://github.com/pandiaaman/GOTFamilyTreeWeb",
    webapp: "",
    portfolio: "",
    youtube: "https://youtu.be/W_3zTbsNWtY",
  },

  {
    id: 7,
    title: "Google Notes App Clone with Servlets and Hibernate",
    role: "independent project",
    date: "July 2021",
    about:
      "Google Keep Notes is a widely used application for note-taking, this project is an efficient approach to recreate the application using Hibernate with Servlet and JSP in Java. The application allows users to sign up, log in, log out, save notes, pin notes, etc, based on the user’s requirements. ",
    description:
      "Using Java Servlets, JSP, Hibernate, JavaScript, and TailwindCSS for the front end, this project covers all the essentials in the area of complete web application using the core technologies. Exploring the CORS policy (Cross-Origin Resource Sharing), the project also explores the security features that protect users from malicious scripts online. The in-depth usage of servlets with XML (deployment descriptors) in the web application, provides a proper template for usage with frontend technologies like React and core JavaScript. Notes by the users are stored in a SQL database PostgreSQL, for efficient retrieval and saving of the notes using the hibernate library.",
    learnings:
      "This project helped me understand the use of core technologies like Servlets, JSP, JavaScript, and CORS efficiently. Session management using Java is done in a way to provides the users with the best experience along with multithreading implementation in the application to process the requests faster. Using SessionFactory in the Hibernate library, to save and fetch the results along with writing the HQL (Hibernate Query Language) to query specific results from the database. Use of proper logging mechanism with Log4J, implementing RollingFile and Loggers to create rolling log files with time. ",
    image: notes,
    tags: [
      "Java servlets",
      "hibernate",
      "SQL",
      "JSP",
      "CORS",
      "multi threading",
      "junit testing",
      "selenium",
      "deployment",
    ],
    category: "fullstack",
    github:
      "https://github.com/pandiaaman/GoogleNotesCloneHibernateServletJsp/tree/master",
    webapp: "",
    portfolio: "",
    youtube: "",
  },

  {
    id: 8,
    title: "Analyzing Cardio Fitness Data using R and Machine Learning",
    role: "independent project",
    date: "Sep 2019",
    about:
      "The objective of the project is to explore the cardio data set (“CardioGoodFitness”) in R and generate insights about the data set. The data CardioGoodFitness shows the data for multiple individuals using various cardio devices of different brands to keep track of their day-to-day activities. ",
    description:
      "Holding the responsibility of a data scientist, I performed an in-depth exploratory data analysis, such as variable identification, univariate analysis, bi-variate analysis, feature exploration, and outlier detection, gaining various valuable insights into the data provided. I explored the process of decision-making and using the inferences from data to better use by predicting and understanding the effects of data. ",
    learnings:
      "I explored the provided data and various methods to get meaning out of it, by doing this, I delved deeper into the process of data manipulation, trend analysis, and data visualization. I used the R language to implement multiple data exploration methods, helping me to make valuable inferences on each identified variable. The project helped me understand different ways of importing and exporting data from and to different sources in our working directory. I explored using R package libraries like dplyr(for filter and search), caret(for predictive modeling), stats(for statistical analysis), and ggplot2(for data visualization).",
    image: cardio,
    tags: [
      "data science",
      "machine learning",
      "R",
      "Python",
      "Bid Data",
      "ANOVA",
      "Regression",
      "Exploratory analysis",
    ],
    category: "dsml",
    github: "",
    webapp: "https://eportfolio.mygreatlearning.com/aman-pandia",
    portfolio:
      "https://docs.google.com/document/d/1aetbM4gV9ublzgOXhUmWcNP0yKmeGzzk/edit?usp=sharing&ouid=114222733943054360696&rtpof=true&sd=true",
    youtube: "",
  },
];

export const research = [
  {
    id: 0,
    title: "Autonomous Car Parking System",
    role: "co-researcher",
    teamsize: "2",
    publisher: "IJARBEST",
    date: "15 May, 2018",
    description:
      "As the number of cars is increasing it is leading to a number of problems such as the area is becoming more congested leading to the immense traffic on road and even lesser space for parking the vehicles. Hence emerges the main problem which includes finding space for parking or manoeuvring the car in the parking space which becomes very difficult because of the congestion. The Parking alert system will make sure that no other vehicle comes and parks in vicinity to the car in a way that it becomes difficult for the driver to get in the car or it gets difficult for the driver to manoeuvre the vehicle later out of the parking space. We aim to create the system that turns on as the vehicles gets parked and alerts the driver of the other vehicle to park at a distance in order to give the vehicle passage for manoeuvring. In the system a microcontroller will be installed along with four ultrasonic sensors on all four sides of the vehicle and an alarm that acts as an actuator. The system actuates only when a certain condition arises which are coded according to the algorithm used in the microcontroller. ",
    image: carparking,
    tags: [
      "machine learning",
      "computer vision",
      "algorithms",
      "car parking",
      "Python",
      "sensor programming",
      "IMU & Gyroscopes",
    ],
    category: "all",
    paperlink: "https://ijarbest.com/journal/v4i5/1650",
  },
  {
    id: 1,
    title: "Hybrid Solar-Wind Power System",
    role: "co-researcher",
    teamsize: "2",
    date: "3 May, 2018",
    description:
      "Development, promotion and application of renewable energy resources has certainly become the need of the hour. With exponential increment in demand and usage of non-renewable energy resources, we all are aware that the time isn’t very far for complete extinction of these resources, leaving us vulnerable. Nations competing with each other for socio economic development are highly dependent on their energy resources and the source of this energy. Over the past few decades, inclination towards the renewable resources has been continuous, giving scope to a much cleaner source of energy, be it due to global warming or depletion of fossil fuels. This paper concentrates on studying the provision of reliable electric system using solar-wind hybrid power systems that harnesses the renewable energy in sun and wind to generate electricity, taking into account maximum power point tracking. Hybrid nature of the system brings redundancy with it, increasing reliability and reducing the dependency on the single source. Measurement and analysis of the preferred site has been done in order to check availability of the resources. Since the capacity factor of the power systems running on renewable resources is more of a question of availability of wind or sun, as they are random in speed, direction and time, and are mostly affected by weather, hence combining both as a hybrid, to harness power can be much more reliable and realistic power source.",
    image: solarwind,
    tags: [
      "Sustainability",
      "renewable energy",
      "Sensor programming",
      "maximum value calculations",
      "calculus",
    ],
    category: "all",
    paperlink: "https://ijarbest.com/journal/v4i5/1648",
  },
];

export const achievements = [
  {
    id: 0,
    name: "Hitachi GL Role Model Award",
    date: "Sep 2025",
    desc: "I was awarded 'Role Model in Challenging times' for my contributions to a critical project at a critical time. In just a year with the company, I’ve had the opportunity to work on multiple important projects, make key technical decisions, and see my ideas come to life.",
    img: "https://media.licdn.com/dms/image/v2/D5622AQHGGP_DtCjweQ/feedshare-shrink_1280/B56ZnCw4i0IsAs-/0/1759909219369?e=1762992000&v=beta&t=BuHoctL6k_FeSXaAJcGW6RM7KlCdCwCG9loxtQiHyi8",
    rolemodel:
      "https://www.linkedin.com/feed/update/urn:li:activity:7381594285898592256/",
  },
  {
    id: 1,
    name: "AirForce Pilot Recommendation",
    date: "Jan 2021",
    desc: "I was recommended/selected by the Indian AirForce for the position of Officer as a Pilot in the force.",
    img: airforce,
    airforce:
      "https://drive.google.com/file/d/1RiFP3cemo0exyndMoGmLxRg4we5Hav6x/view?usp=sharing",
  },
  {
    id: 2,
    name: "Hitachi GL Best team",
    date: "Jun 2025",
    desc: "Our team of 4 members led by me, was awarded the 'best team award' for the year at Hitachi GL.",
    img: "https://cdn2.vectorstock.com/i/1000x1000/97/91/best-team-golden-badge-laurel-branches-award-sign-vector-40079791.jpg",
    bestteam:
      "https://drive.google.com/file/d/1RiFP3cemo0exyndMoGmLxRg4we5Hav6x/view?usp=sharing",
  },
  {
    id: 3,
    name: "State Street Employee Recognition Award",
    date: "March 1, 2024",
    desc: "Recognized by the CEO of State Street, for my involvement in microservice application as a software architect and developer.",
    img: bravo2,
    ssemp:
      "https://drive.google.com/file/d/1anXXeEXg_nKq9KeNK5m3rcUodo1NM9Lt/view?usp=sharing",
  },
  {
    id: 4,
    name: "NGO Community service",
    date: "2018-current",
    desc: "Worked with multiple NGOs dedicated to improving the education, medical and economic conditions of lower classes in India.",
    img: ngo,
    ngo: "https://drive.google.com/file/d/1l-AUJgNkzE1b2XDYb5YxTSRNtNDrybf9/view?usp=sharing",
  },
  {
    id: 5,
    name: "IELTS ScoreCard",
    date: "Dec 2023",
    desc: "Received a band 8 in IELTS general exam, gaining 8.5 in listening and reading both and a 7.5 score in speaking.",
    img: ielts,
    ielts:
      "https://drive.google.com/file/d/1k_8WQH_acaTDKlmrcJpJWscYDejxBPec/view?usp=sharing",
  },

  {
    id: 6,
    name: "StateStreet Employee Of the Month",
    date: "April 20, 2023",
    desc: "Recognized by my then manager, Anandha Prabhu, for my conitnuous efforts in managing a middleware service application solely.",
    img: bravo1,
    ssemp:
      "https://drive.google.com/file/d/1BG2zv62mgjOGohmJ3uZPcQRidA9EykwT/view?usp=sharing",
  },
];

export const TimeLineData = [
  { year: 2015, text: "Began my undergrad in Information Technology" },
  { year: 2017, text: "Became the lead of the SRMSAT's ADCS department" },
  { year: 2018, text: "Developed and tested Vigilant Stick" },
  { year: 2019, text: "Started my professional journey" },
  { year: 2021, text: "Received my first patent" },
  { year: 2022, text: "Recommended by the Indian Air Force for fighter pilot" },
  { year: 2023, text: "Became a project lead in State Street" },
];
